import {createRouter, createWebHistory, NavigationGuardNext, RouteLocationNormalized, RouteRecordRaw} from 'vue-router'

import SericeRoute from './modules/service'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'IndexLayout',
    redirect: {name: 'Index'},
    component: () => import('../layout/MainPageLayout.vue'),
    children: [
      // 首页
      {
        path: 'home',
        name: 'Index',
        component: () => import('@/views/Index/Index.vue'),
      },
      // 所有分类
      {
        path: 'category',
        name: 'Category',
        component: () => import('@/views/Category/Index.vue'),
      },
      {
        path: 'calculate',
        name: 'Calculate',
        component: () => import('@/views/Calculate/Index.vue'),
      },
      {
        path: 'self-service',
        name: 'SelfService',
        component: () => import('@/views/SelfService/Index.vue'),
      },
       {
        path: 'add-self-service',
        name: 'AddSelfService',
        component: () => import('@/views/SelfService/AddSelfService.vue'),
      },
      // 所有分类-首页
      {
        path: 'categoryhome',
        name: 'CategoryHome',
        component: () => import('@/views/CategoryHome/Index.vue'),
      },
      // 卖家 mercari
      {
        path: 'sellers-mercari',
        name: 'SellersMercari',
        component: () => import('@/views/SellersMercari/Index.vue'),
      },
      // 卖家乐天 mercariRakuten
      {
        path: 'sellers-rakuten',
        name: 'SellersRakuten',
        component: () => import('@/views/SellersRakuten/Index.vue'),
      },
      // 卖家 SellersYahoo
      {
        path: 'sellers-yahoo',
        name: 'SellersYahoo',
        component: () => import('@/views/SellersYahoo/Index.vue'),
      },
      // 商品详情
      {
        path: 'detail',
        name: 'ProductDetail',
        component: () => import('@/views/ProductDetail/Index.vue'),
      },
      // 购物车
      {
        path: 'shopcar',
        name: 'ShopCar',
        component: () => import('@/views/ShopCar/Index.vue'),
      },
      // 结算台
      {
        path: 'settlement',
        name: 'Settlement',
        component: () => import('@/views/Settlement/Index.vue'),
      },
      // 帮助中心
      {
        path: 'helpcenter',
        name: 'HelpCenter',
        component: () => import('@/views/HelpCenter/Index.vue'),
      },
      // 我的
      {
        path: 'mine',
        name: 'Mine',
        component: () => import('../layout/PersonalLayout.vue'),
        redirect: {name: 'Orders'},
        children: [
          // 我的订单
          {
            path: 'orders',
            name: 'Orders',
            component: () => import('@/views/Orders/Index.vue'),
            meta: {
              key: '1',
            }
          },
          // 订单详情
          {
            path: 'orderDetail',
            name: 'OrderDetail',
            component: () => import('@/views/OrderDetail/Index.vue'),
            meta: {
              key: '1',
            }
          },
          // 发货包裹订单详情
          {
            path: 'packageDetail',
            name: 'PackageDetail',
            component: () => import('@/views/PackageDetail/Index.vue'),
            meta: {
              key: '1',
            }
          },
          // 拍卖订单
          {
            path: 'auction',
            name: 'Auction',
            component: () => import('@/views/Auction/Index.vue'),
            meta: {
              key: '2',
            }
          },
          // 拍卖订单详情 AuctionDetail
          {
            path: 'auctionDetail',
            name: 'AuctionDetail',
            component: () => import('@/views/AuctionDetail/Index.vue'),
            meta: {
              key: '2',
            }
          },
          // 集运地址
          {
            path: 'zyaddress',
            name: 'Zyaddress',
            component: () => import('@/views/Zyaddress/Index.vue'),
            meta: {
              key: '7',
            }
          },
          // 我的收藏
          {
            path: 'collection',
            name: 'Collection',
            component: () => import('@/views/Collection/Index.vue'),
            meta: {
              key: '5',
            }
          },
          // 身份认证
          {
            path: 'identity_authentication',
            name: 'IdentityAuthentication',
            component: () => import('@/views/IdentityAuthentication/Index.vue'),
            meta: {
              key: '4',
              childrenKey: '14',
            }
          },
          // 账户设定
          {
            path: 'account_setting',
            name: 'AccountSetting',
            component: () => import('@/views/AccountSetting/Index.vue'),
            meta: {
              key: '4',
              childrenKey: '13',
            }
          },
          // 地址管理
          {
            path: 'address_manage',
            name: 'AddressManage',
            component: () => import('@/views/AddressManage/Index.vue'),
            meta: {
              key: '4',
              childrenKey: '12',
            }
          },
          // 优惠券 coupon
          {
            path: 'coupon',
            name: 'Coupon',
            component: () => import('@/views/Coupon/Index.vue'),
            meta: {
              key: '6',
            }
          },
          // 资金管理
          {
            path: 'fund_management',
            name: 'FundManagement',
            component: () => import('@/views/FundManagement/Index.vue'),
            meta: {
              key: '4',
              childrenKey: '11',
            }
          },
          // 竞拍信用等级
          {
            path: 'credit_rank',
            name: 'CreditRank',
            component: () => import('@/views/CreditRank/Index.vue'),
            meta: {
              key: '4',
              childrenKey: '15',
            }
          },
          {
            path: 'user_level',
            name: 'UserLevel',
            component: () => import('@/views/UserLevel/Index.vue'),
            meta: {
              key: '4',
              childrenKey: '16',
            }
          },
          // 提交发货
          {
            path: 'shipment',
            name: 'Shipment',
            component: () => import('@/views/Shipment/Index.vue'),
          },


          ...SericeRoute,
        ]
      },
    ],
  },

  // 注册/登入等
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/Register/Index.vue'),
    meta: {
      isAuth: false,
    },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/Index.vue'),
    meta: {
      isAuth: false,
    },
  },
  {
    path: '/wechat_login',
    name: 'WechatLogin',
    component: () => import('@/views/WechatLogin/Index.vue'),
    meta: {
      isAuth: false,
    },
  },
  {
    path: '/wechat_bind',
    name: 'WechatBind',
    component: () => import('@/views/WechatBind/Index.vue'),
    meta: {
      isAuth: false,
    },
  },
  {
    path: '/line_callback',
    name: 'LineCallback',
    component: () => import('@/views/LineCallback/Index.vue'),
    meta: {
      isAuth: false,
    },
  },
  {
    path: '/line_bind',
    name: 'LineBind',
    component: () => import('@/views/LineBind/Index.vue'),
    meta: {
      isAuth: false,
    },
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('@/views/Test.vue'),
    meta: {
      isAuth: false,
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404.vue'),
    meta: {
      isAuth: false,
    },
  },
  {
    path: '/auction_center',
    name: 'AuctionCenter',
    component: () => import('@/views/AuctionCenter/Index.vue'),
    meta: {
      isAuth: false,
    },
  },
  {
    path: '/invite_register',
    name: 'InviteRegister',
    component: () => import('@/views/InviteRegister/Index.vue'),
    meta: {
      isAuth: false,
    },
  },
  {
    path: '/:catchAll(.*)', // 404 页面
    redirect: '/',
    meta: {
      isAuth: false,
    },
  },
]

const routerBase =
  (typeof window !== 'undefined' && (window as any).__APP_BASE__) || process.env.BASE_URL

const router = createRouter({
  history: createWebHistory(routerBase),
  routes,
  scrollBehavior() {
    return {top:0,left:0}
  }
})

router.beforeEach((to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {

  const html: any = document.querySelector('.main-page-content')
  if (html) {
    html.scrollTo(0,0)
  }

  next()
})

export default router
